export default __webpack_public_path__ + "static/Sprint3_Planning_OffshoreWind-97276e97f8e0b7893ab5100828f83848.mp4";